
























import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

const DayKeyNameMapping = {
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun'
}

const DefaultFromTimeMapping = {
    mon: '09:00',
    tue: '09:00',
    wed: '09:00',
    thu: '09:00',
    fri: '09:00',
    sat: null,
    sun: null
}

const DefaultToTimeMapping = {
    mon: '17:00',
    tue: '17:00',
    wed: '17:00',
    thu: '17:00',
    fri: '17:00',
    sat: null,
    sun: null
}

@Component({
    components: {}
})
export default class BusinessDay extends Vue {
    @Prop() dayKey!: 'mon'|'tue'|'wed'|'thu'|'fri'|'sat'|'sun'
    @Prop() value!: string[][]
    @Prop({ default: true }) disabled!: boolean
    fromTime: string|null = DefaultFromTimeMapping[this.dayKey]
    toTime: string|null = DefaultToTimeMapping[this.dayKey]

    get dayName(): string {
        return DayKeyNameMapping[this.dayKey]
    }

    addTimeRange() {
        // TODO: Validation
        if (this.fromTime && this.toTime) {
            this.value.push([this.fromTime, this.toTime])
            this.fromTime = DefaultFromTimeMapping[this.dayKey]
            this.toTime = DefaultToTimeMapping[this.dayKey]
        }
    }

    @Emit('input')
    handleInput() {
        return this.value
    }
}
